<template>
	<div class="display-flex flex-row flex-align-center my-1">
		<div class="selected-container" v-for="app in currentSelectedApps" :key="app.id">
			<CurrentSelectedAppCard class="mr-2" :app="app" />
			<AnemicButton @click="$emit('remove-app', app)" rounded class="pa-0 close-button">x</AnemicButton>
		</div>
	</div>
</template>
<script>
import CurrentSelectedAppCard from '@/components/SelectFavoriteApps/CurrentSelectedAppCard.vue';
export default {
	name: 'CurrentSelectedApps',
	props: { currentSelectedApps: { type: Array } },
	components: { CurrentSelectedAppCard },
};
</script>
<style lang="scss" scoped>
.selected-container {
	min-height: 30px;
	max-height: 30px;
}
.close-button {
	top: -44px;
	left: 22px;
	position: relative;

	height: 14px !important;
	font-size: 8px !important;
	min-width: 14px !important;
	background: var(--white) !important;
	border: 1px solid #707070 !important;
}
</style>
